<template>
  <svg
    :width="size"
    :height="(size * 34) / 38"
    viewBox="0 0 38 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M31.2257 18.7775L29.0119 16.5636C28.2597 15.8115 27.0504 15.7797 26.2597 16.4913L19.7744 22.3281C19.1422 22.897 18.7812 23.7075 18.7812 24.558V32.9997H24.5789C25.4162 32.9997 26.2154 32.6498 26.7833 32.0345L35.7634 22.306C36.275 21.7518 36.559 21.0253 36.559 20.2712V6.33301H33.2257C32.1211 6.33301 31.2257 7.22844 31.2257 8.33301V18.7775ZM31.2257 18.7775L25.8924 24.1108"
      :stroke="color"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.3368 18.7775L8.55062 16.5636C9.30279 15.8115 10.5121 15.7797 11.3028 16.4913L17.7881 22.3281C18.4203 22.897 18.7812 23.7075 18.7812 24.558V32.9997H12.9836C12.1463 32.9997 11.3471 32.6498 10.7792 32.0345L1.79906 22.306C1.28752 21.7518 1.00347 21.0253 1.00347 20.2712V6.33301H4.3368C5.44137 6.33301 6.3368 7.22844 6.3368 8.33301V18.7775ZM6.3368 18.7775L11.6701 24.1108"
      :stroke="color"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M24.112 8.88315C23.1069 10.5511 21.2782 11.6667 19.1889 11.6667C16.0168 11.6667 13.4453 9.09517 13.4453 5.92308C13.4453 3.83378 14.5609 2.00504 16.2288 1"
      :stroke="color"
      stroke-width="2"
      stroke-linecap="round"
    />
    <path
      d="M22.3359 2.77734H22.3519"
      :stroke="color"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    size?: number;
    color?: string;
  }>(),
  {
    size: 56,
    color: "currentColor",
  },
);
</script>
